<template>
    <div class="skill-set-empty-state" data-testid="profile-main-skill-set-empty-state">
        <VJoyIcon name="list-file" size="medium" />
        <VJoyText tag-name="p" preset="primary-450">{{ t('profile.section.skill.set.empty.state.title') }}</VJoyText>
        <VJoyText tag-name="p" preset="primary-400">{{ t('profile.section.skill.set.empty.state.description') }}</VJoyText>
        <VJoyButton variant="secondary" icon="add" @click="emit('add')">
            {{ t('profile.section.skill.set.empty.state.cta') }}
        </VJoyButton>
    </div>
</template>

<script setup lang="ts">
    import {useTranslation} from '#imports';
    import {VJoyButton, VJoyIcon, VJoyText} from '@maltjoy/core-vue';

    const {t} = useTranslation();
    const emit = defineEmits<{add: []}>();
</script>

<style lang="scss" scoped>
    .skill-set-empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: var(--joy-core-spacing-4);
        padding: var(--joy-core-spacing-6) 0;
    }
</style>
